<template>
	<div>
		<headerView v-show="showHeader" ref="Header" :width="width"/>
		<div class="routerViewBox" :class="{ messagePwaMode: isMessagePwaMode, myLiveRoomChatPwaMode: isMyLiveRoomChatPwaMode }">
			<router-view v-slot:="{Component,route}" >
				<component ref="routerViewRef" :is="Component" />
			</router-view>
		</div>
		<footerViwe v-if="showFooter"></footerViwe>
		<el-backtop v-if="!isMessagePwaMode && !isMyLiveRoomChatRoute" />
		<showLogin ref="showLoginRef" v-if="!isMyLiveRoomChatRoute"></showLogin>
		<el-dialog
			v-model="ad20Opt.visible"
			@close="ad20Opt.close"
			class=""
			header-class="headerClass"
			body-class="bodyClass"
			:show-close="false"
			append-to-body
			top="50vh"
			>
				<div class="ad20Box flex-center">
					<img :src="ImageParameterSplicing(ad20Opt.item.imgURL||'',1000)" @click.stop="ad20Opt.adClick(ad20Opt.item)">
					<div class="close" @click.prevent="ad20Opt.visible = false">
						<el-icon><CircleClose /></el-icon>
					</div>
				</div>
		</el-dialog>
	</div>
</template>

<script setup>
	import headerView from '@/components/layout/header';
	import footerViwe from '@/components/layout/footer';
	import {ref,reactive,onMounted,getCurrentInstance,computed,onUpdated,watch,provide} from 'vue';
	const {proxy} = getCurrentInstance();//当前实例
	import { useStore } from '@/store';
	import {routes} from '@/router';
	import _chatManager from '@/utils/tencentCloudChat';
	import VConsole from 'vconsole';
	if(proxy.$route.query.debug){
		new VConsole();
	}
	const chatManager = new _chatManager(proxy);
	// console.log('chatManager',chatManager);
	provide('chatManager', chatManager);
	let store = useStore();
	proxy.request.store = store;
	let syncManifestByRoute = (path = '')=>{
		if(typeof document === 'undefined') return;
		let isChatroomRoute = /^\/member2?\/anchor(?:\/|$)/.test(path) || /^\/MyliveRoomChat(?:\/|$)/.test(path);
		let isMessageRoute = /^\/message(?:\/|$)/.test(path);
		let siteName = window.mainbodyConfig && window.mainbodyConfig.site_name ? window.mainbodyConfig.site_name : '某某体育';
		let appName = siteName;
		let manifestHref = '/lib/manifest.json';
		let installMode = 'main';
		if(isChatroomRoute){
			appName = siteName + ' 聊天室';
			manifestHref = '/lib/manifest-chatroom.json';
			installMode = 'chatroom';
		}else if(isMessageRoute){
			appName = siteName + ' IM';
			manifestHref = '/lib/manifest-im.json';
			installMode = 'im';
		}

		let manifestNode = document.getElementById('app-manifest');
		if(!manifestNode){
			manifestNode = document.createElement('link');
			manifestNode.setAttribute('rel','manifest');
			manifestNode.setAttribute('id','app-manifest');
			manifestNode.setAttribute('crossorigin','use-credentials');
			document.head.appendChild(manifestNode);
		}
		if(manifestNode.getAttribute('href') !== manifestHref){
			manifestNode.setAttribute('href',manifestHref);
		}

		let appleTitleNode = document.getElementById('apple-mobile-web-app-title');
		if(appleTitleNode){
			appleTitleNode.setAttribute('content', appName);
		}
		window.__qx2InstallMode = installMode;
		window.__qx2PwaAppName = appName;
	}
	let currentPath = computed(()=>proxy.$route.path || window.location.pathname || '');
	let isMessagePwaMode = computed(()=>/^\/message(\/|$)/.test(currentPath.value) && `${proxy.$route.query.pwa || ''}` === 'true');
	let isMyLiveRoomChatRoute = computed(()=>/^\/MyliveRoomChat(\/|$)/i.test(currentPath.value));
	let isMyLiveRoomChatPwaMode = computed(()=>isMyLiveRoomChatRoute.value && `${proxy.$route.query.pwa || ''}` === 'true');
	// 不需要导航头的路由
	let headerNotNeed = ['signIn'];
	// 不需要页尾的路由
	let footerNotNeed = ['signIn'];
	let whiteList = [];//白名单
	// 是否显示导航头
	let showHeader = computed(()=>{
		if(isMessagePwaMode.value || isMyLiveRoomChatRoute.value){
			return false;
		}
		let has = whiteList.find(e=>e == proxy.$route.path);
		if(has){
			return true;//符合白名单直接跳过
		}
		return !headerNotNeed.find(e=>new RegExp(e,'i').test(proxy.$route.path));
	});
	// 是否显示页尾
	let showFooter = computed(()=>{
		if(isMessagePwaMode.value || isMyLiveRoomChatRoute.value){
			return false;
		}
		if(/^\/message(\/|$)/.test(currentPath.value)){
			return false;
		}
		let has = whiteList.find(e=>e == proxy.$route.path);
		if(has){
			return true;//符合白名单直接跳过
		}
		return !footerNotNeed.find(e=>new RegExp(e,'i').test(proxy.$route.path));
	})
	let _userInfo = proxy.localStorage.getItem('userInfo');
	let userInfo = {};
	if(_userInfo){
		// console.log(';_userInfo',_userInfo);
		userInfo = JSON.parse(_userInfo);
		if(userInfo.id){
			proxy.getUserInfo(store);
		}
	}
	// store.action.user.resetUserStore();
	store.action.user.updateUser(userInfo);//设置用户信息
	watch(()=>store.state.user.id,(val,oldVal)=>{
		if(oldVal && !val){//用户退出登录
			console.log('用户退出登录');
			chatManager.logout();//退出登录
			store.action.currChatUser.clear();//清空当前会话对象
			if(/member/.test(proxy.$route.path)){
				// 在个人中心里需要退回，避免退出登录后继续操作数据
				proxy.$router.replace('/');
			}
		}
	})
	proxy.StartUpObj().then(({data})=>{
		// console.log('startUp',data.data);
		store.action.startUp.set(data.data);
		store.action.indexContentTabs.set(data.data.indexContentTabs);//资讯首页tab
		store.action.indexLiveTabs.set(data.data.indexLiveTabs);//直播首页的tab
		store.action.chatroomCommonWords.set(data.data.chatroomCommonWords||[]);
		data.data.configData.RTCAppKey&&chatManager.create(data.data.configData.RTCAppKey);//连接腾讯chat
		proxy.localStorage.setItem('supportResStyleDomains',JSON.stringify(data.data.configData.supportResStyleDomains??[]));
		let has = data.data.advertData.find(e=>e.nativeType == 5);
		if(has){
			let imgUrl = has.advertImageUrl;
			proxy.mainbodyConfig.defineTvLogo = imgUrl;
		}
	}).catch(err=>{
		console.log(err);
	});
	// 判断显示404页面时需不要显示导航头
	// let showHeader404 = ref(true);
	// watch(()=>proxy.$route.path,(path,oldPath)=>{
	// 	// console.log('APP-watchRouter:',path,oldPath)
	// 	let form = headerNotNeed.find(e=>new RegExp(e,'i').test(oldPath));
	// 	if(form&&path=='/404'){
	// 		showHeader404.value = false;
	// 	}else{
	// 		showHeader404.value = true;
	// 	}
	// })
	let width = ref(1240);
	watch(()=>proxy.$route.path,(path,oldPath)=>{
		// console.log('APP-watchRouter:',path,oldPath)
		syncManifestByRoute(path);
		// let form = ['live','liveRoomDetails'].find(e=>new RegExp(e,'i').test(path));
		// if(form){
		// 	width.value = '100%';
		// }else{
		// 	width.value = 1240;
		// }
	},{immediate:true})
	let getDeviceID = ()=>{
		let qx2DeviceID = proxy.localStorage.getItem('qx2DeviceID');
		if(qx2DeviceID)return;//而是检查到没有设备ID，才会去拿新的，否则会沿用旧的（同一台设备）
		qx2DeviceID = proxy.newGuid().replace(/-/g,'');
		proxy.localStorage.setItem('qx2DeviceID',qx2DeviceID);//由本地生成
		// proxy.request({
		// 	serv:'statistic',
		// 	url:'GetDeviceID',
		// 	method:'POST',
		// }).then(({data})=>{
		// 	// console.log('GetDeviceID',data)
		// 	if(data.Code==200||data.code==200){
		// 		if(data.Data){
		// 			let deviceID = data.Data.DeviceID;
		// 			if(deviceID){
		// 				proxy.localStorage.setItem('qx2DeviceID',JSON.stringify({ qx2DeviceID:deviceID }));
		// 				proxy.request({
		// 					serv:'statistic',
		// 					url:'AddDeviceRecord',
		// 					data:{
		// 						DeviceID: deviceID,
		// 						Source:5,
		// 						Language:navigator.language,
		// 					},
		// 					method:'POST',
		// 				}).then(({data})=>{
		// 					// console.log('AddDeviceRecord',data);
		// 				}).catch(err=>{
		// 					console.log('AddDeviceRecord',err);
		// 				})
		// 			}
		// 		}
		// 	}
		// }).catch(err=>{
		// 	console.log('GetDeviceID',err);
		// })
	}
	getDeviceID();
	
	
	import { useI18n } from 'vue-i18n';
	const { t:$t } = useI18n();
	proxy.$t = $t;
	
	let shieldList = proxy.localStorage.getItem('shieldList');
	if(shieldList){
		try{
			shieldList = JSON.parse(shieldList);
			store.action.shieldList.set(shieldList);
		}catch(err){
			console.log('解析屏蔽列表时（聊天室的不看ta）出错了',err);
		}
	}
	
	let replace403 = (res)=>{
		if(proxy.$route.path == '/403')return;
		proxy.$router.replace({ path: '/403', query: { from: proxy.$route.fullPath,ip: res.data.IP } });
	}
	let _replace403 = proxy.debounce(replace403);
	
	let showLoginRef = ref();
	onMounted(()=>{
		// Phase E: 统一订阅 request 层最终错误，使用 ElMessage 展示（H5 项目请改为对应 Toast）
		proxy.$bus.on('request:error', ({ message }) => {
			if (message) proxy.$showElMessage({ message, type: 'error', duration: 3000 });
		});
		proxy.$bus.on('userLogined', ( userInfo ) => {
			store.action.user.updateUser(userInfo);
		});
		proxy.$bus.on('http403', ( res ) => {
			_replace403(res);
		});
		proxy.$bus.on('triggerLogin', ( ) => {
			store.action.user.resetUserStore();
			proxy.localStorage.setItem('token', '');
		});
		proxy.$bus.on('showLogin',()=>{
			if(isMyLiveRoomChatRoute.value){
				proxy.$bus.emit('showLoginPopup');
				return;
			}
			showLoginRef.value && showLoginRef.value.show();
		})
		window.getChatUserInfo = chatManager.getUserInfo;
		// 读取本地的是否开启通知
		let _notification = proxy.localStorage.getItem('notification');
		if(_notification){
			store.action.notification.set(_notification=="true");
		}
		chatManager.registerEvents([
			// SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能。
			// {
			// 	event:chatManager.TencentCloudChat.EVENT.SDK_READY,//SDK就绪
			// 	handler:async(e)=>{
			// 		console.log(chatManager.TencentCloudChat.EVENT.SDK_READY,e);
					
			// 	},
			// },
			{
				event:chatManager.TencentCloudChat.EVENT.FRIEND_LIST_UPDATED,
				handler:async(e)=>{
					console.log('好友列表更新事件',e);
					// 获取好友列表
					// contactsLoading.value = true;
					try{
						var res = await chatManager.getFriendList();
						if(res.data && Array.isArray(res.data)){
							store.action.set('friendList',res.data);
							console.log('app-friendList',res.data);
						}
					}catch(err) {
						console.err("app-getAllContacts failed",err);
					}finally{
						
					}
				}
			},
		])
	})
	
	
	let getCustomerServiceList = ()=>{
		proxy.request({
			url:'CustomerServiceList',
			method:'post',
			notips:true,
		}).then(({data})=>{
			// console.log('获取客服列表',data.data);
			if(data.code==200){
				store.action.set('customerServiceList',data.data);
			}
		})
	}
	getCustomerServiceList();//获取客服列表
	
	// 获取广告数据
	watch(()=>proxy.$route.path,(path,oldPath)=>{
		if(/^\/$/.test(oldPath) && /^\/home$/.test(path)){
			proxy.getLiveAdvertisingData({
				cityID: 0,
			}).then(data=>{
				ad20Opt.show(data);
			})
		}
	})

	onMounted(()=>{
		// if(/^\/$/.test(proxy.$route.path)||/^\/home$/.test(proxy.$route.path)){
		// 	proxy.getLiveAdvertisingData({
		// 		cityID: 0,
		// 	}).then(data=>{
		// 		ad20Opt.show(data);
		// 	})
		// }
	})

	let ad20Opt = reactive({
		visible:false,
		data:[],
		item:{},
		show:(data)=>{
			ad20Opt.data.length = 0;
			data?.forEach(e=>{
				if(e.advertisingContent && typeof e.advertisingContent == 'string'){
					try{
						e.advertisingContent = JSON.parse(e.advertisingContent);
					}catch(err){}
				}
				ad20Opt.data.push(e);
			});
			let ad20 = ad20Opt.data.filter(e=>e.advertisingType == 20);
			console.log('ad20',ad20,ad20Opt.data);
			if(ad20.length){//首页居中广告
				ad20Opt.item = ad20[proxy.intervalRandom(0,ad20.length-1)];// 随机选出一枚
				ad20Opt.visible = true;
			}
		},
		close:()=>{
			ad20Opt.data = [];
			ad20Opt.item = {};
		},
		adClick:(item)=>{
			let url = item.jumpLink;
			if(!url)return;
			if(url.match(RegExp('^https:\/\/|http:\/\/'))){
				let pathname = '';
				if(typeof URL == 'function'){
					pathname = new URL(url).pathname;
				}else{
					pathname = proxy.parseUrl(url).pathname;
				}
				let has = ['cg','g','u'].map(e=>RegExp(`^\/${e}\/[a-zA-Z0-9]+$`).test(pathname)).some(e=>e);
				if(has){//显示入群引导
					if(!userInfo.value.id){
						proxy.$bus.emit('showLogin');
						return 
					}
					businessCardOpt.show(url);
				}else{
					window.open(url, '_blank');
				}
			}else{
				// 检查是否存在路由
				let allRoutes = proxy.$router.getRoutes();
				let has = allRoutes.find(e=>e.path == url);
				console.log('判断内部跳转',url,has);
				if(has){
					proxy.$router.push({
						path:url,
					})
				}else{
					window.open(url, '_blank');
				}
			}
		}
	})

</script>

<style lang="scss" scoped>
	.ad20Box{
		max-width: 1200px;
		max-height: 670px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		img {
			width: 100%;
		}
		.close{
			position: absolute;
			left: 50%;
			bottom: 0;
			transform: translate(-50%, calc(100% + 25px));
			font-size: 40px;
			color: #fff;
			font-weight: bold;
			cursor: pointer;
			user-select:none;
			outline: none;
		}
	}
</style>
<style lang="scss">

	// @font-face {
	// 	font-family: 'MicrosoftYaHei';
	// 	src: url('~@/assets/font/MicrosoftYaHei.ttf');
	// 	font-display: swap;
	// }
	// @font-face {
	// 	font-family: 'PingFang-SC-Bold';
	// 	src: url('~@/assets/font/PingFang-SC-Bold.ttf');
	// 	font-display: swap;
	// }
	// @font-face {
	// 	font-family: 'PingFang-SC-Medium';
	// 	src: url('~@/assets/font/PingFang-SC-Medium.ttf');
	// 	font-display: swap;
	// }
	// @font-face {
	// 	font-family: 'BigruixianBlackGBV';
	// 	src: url('~@/assets/font/BigruixianBlackGBV.TTF');
	// 	font-display: swap;
	// }
	// @font-face {
	// 	font-family: 'YouSheBiaoTiHei';
	// 	src: url('~@/assets/font/YouSheBiaoTiHei.ttf');
	// 	font-display: swap;
	// }
	:root{
		--qx2-primary-color:#52A401;
		--qx2-primary-lightColor:#D2D54C;
		--qx2-primary-linearGradient-color:linear-gradient(286deg,var(--qx2-primary-color) 0%, var(--qx2-primary-lightColor) 100%);
		--qx2-primary-fillColor-light-9:rgba(82,164,1,0.1);
		--qx2-primary-fillColor-light-8:rgba(82,164,1,0.2);
		--qx2-primary-fillColor-light-7:rgba(82,164,1,0.3);
		--qx2-primary-fillColor-light-6:rgba(82,164,1,0.4);
		--qx2-primary-fillColor-light-5:rgba(82,164,1,0.5);
		--qx2-primary-fillColor-light-4:rgba(82,164,1,0.6);
		--qx2-primary-fillColor-light-3:rgba(82,164,1,0.7);
		--qx2-primary-fillColor-light-2:rgba(82,164,1,0.8);
		--qx2-primary-fillColor-light-1:rgba(82,164,1,0.9);
		--qx2-primary-fillColor-light:rgba(82,164,1,1);
	}
	*{
		margin:0;
		padding:0;
		// 新增
		box-sizing: border-box;
	}
	// html,body{
	// 	margin:0;
	// 	padding:0;
	// }
	body{
		font: "PingFang SC", "Microsoft YaHei", "微软雅黑", "HanHei SC", "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "STHeiti", "WenQuanYi Micro Hei", SimSun, sans-serif !important;
	}
	a {
		color: #333;
		text-decoration: none;
		outline: 0 none;
		cursor: pointer;
	}
	a:focus {
		-moz-outline-style: none;
	}
	li{
		list-style: none;
		border: 0;
	}
	// 滚动条样式 --------
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}
	::-webkit-scrollbar-thumb {
		background: #D7D7D7;
		border-radius: 20px;
	}
	::-webkit-scrollbar-track-piece {
		background: #f2f2f2;
	}
	.confirmButtonClass {
		background: #f56c6c !important;
		border: 1px solid #f56c6c !important;
	}
	.confirmButtonClass-primary{
		background: var(--qx2-primary-color) !important;
		border: 1px solid var(--qx2-primary-color) !important;
	}
	.ellipsis{
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.ellipsis-multiline {
		display: -webkit-box;
		-webkit-line-clamp: var(--lineClamp); /* 定义显示的最大行数 */
		-webkit-box-orient: vertical;  
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word; /* 处理长单词 */
	}
	.flex-center{
		display:flex;
		justify-content: center;
		align-items:center;
	}
	.flex-column{
		display:flex;
		flex-direction: column;
	}
	.flex-align{
		display:flex;
		align-items: center;
	}
	.flex-end{
		display:flex;
		justify-content:flex-end;
	}
	.flex-start{
		display:flex;
		justify-content:flex-start;
	}
	.flex-align-start{
		display:flex;
		align-items:flex-start;
	}
	.container{
		width:100%;
		padding-top: 73px;
		min-height:calc(100vh - (141px));
	}
	.title.withBorder{
		font-family: PingFang-SC-Bold;
		// font-weight: bold;
		font-size: 18px;
		color: #000000;
		position:relative;
		padding-left:13px;
		&:before{
			content:'';
			position:absolute;
			left:0;
			top:50%;
			transform:translate(0%,-50%);
			width: 6px;
			height: 20px;
			background: var(--qx2-primary-linearGradient-color);
		}
	}
	.el-backtop{
		color: var(--qx2-primary-color) !important;
	}
	.disabled-opaque{
		cursor: no-drop!important;
	}
	.disabled{
		opacity: 0.5;
		cursor: no-drop!important;
	}
	.el-select-dropdown__item.is-selected{
		color: var(--qx2-primary-color) !important;
	}
	.el-dropdown-menu{
		.el-dropdown-menu__item{
			color:var(--qx2-primary-color);
			&:not(.is-disabled):focus, &:not(.is-disabled):hover {
			    background-color: var(--qx2-primary-fillColor-light-9);
			    color: var(--qx2-primary-color);
			}
		}
	}
    .routerViewBox {
        width: 100%;
        min-height: calc(100vh - (141px));
    }
	.routerViewBox.messagePwaMode {
		min-height: 100vh;
	}
	.routerViewBox.myLiveRoomChatPwaMode {
		min-height: 100vh;
	}
	.unsetBorder{
		border:unset !important;
	}
</style>
